import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_4 = { "aria-label": "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb mb-0" }
const _hoisted_6 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_7 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_8 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = {
  key: 0,
  class: "row"
}
const _hoisted_12 = { class: "shadowed-card bg-white mb-2 doc-card p-3" }
const _hoisted_13 = { class: "responsive-iframe-wrap mb-3 h-400" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "modal-wrap default-modal" }
const _hoisted_16 = {
  class: "modal fade",
  id: "videoModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_17 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = { class: "modal-header" }
const _hoisted_20 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_22 = { class: "modal-body" }
const _hoisted_23 = { class: "responsive-iframe-wrap mb-3 h-400" }
const _hoisted_24 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YouTube = _resolveComponent("YouTube")
  const _component_EmptyData = _resolveComponent("EmptyData")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('video_tutorials')), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("nav", _hoisted_4, [
          _createVNode("ol", _hoisted_5, [
            _hoisted_6,
            _createVNode("li", _hoisted_7, [
              _createVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('video_tutorials')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("p", null, _toDisplayString(_ctx.$t('learn_how_to_manage_projects')), 1)
    ]),
    _createVNode("div", _hoisted_10, [
      (_ctx.state.videoList.length)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.videoList, (video, videoIndex) => {
              return (_openBlock(), _createBlock("div", {
                class: "col-md-6 mb-3",
                key: videoIndex
              }, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode(_component_YouTube, {
                      src: video.url,
                      ref: "youtube"
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("h4", null, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      onClick: ($event: any) => (_ctx.openVideoModel(video)),
                      "data-toggle": "modal",
                      "data-target": "#videoModal"
                    }, _toDisplayString(video.question), 9, ["onClick"])
                  ])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode(_component_EmptyData, {
              title: _ctx.state.data.title,
              heading: _ctx.state.data.heading
            }, null, 8, ["title", "heading"])
          ]))
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _createVNode("h5", _hoisted_20, _toDisplayString(_ctx.state.data.selectVideo.question), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeVidoeModel && _ctx.closeVidoeModel(...args)))
              }, [
                _hoisted_21
              ])
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _createVNode(_component_YouTube, {
                  src: _ctx.state.data.selectVideo.url,
                  ref: "youtube"
                }, null, 8, ["src"])
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-dismiss": "modal",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeVidoeModel && _ctx.closeVidoeModel(...args)))
              }, _toDisplayString(_ctx.$t('cancel')), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}